import type { IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import { withWidths } from './formWidths';
import { formPatchOf } from './formPatch';
import { isSeededLayout } from './protoForm';
import { standardFormOf } from './standardForm';

/**
 * Перевизначення після «Скинути до стандартного» (прототип v4 feReset — вилучає layout простору): явні ширини полів зникають; якщо
 * опублікована форма — засіяний прототипом макет (`published`), повна форма стає стандартним макетом; інакше форма редактора вилучається,
 * а простір із формою-формою прототипу (парламент: `forms.context` перевизначення з тим самим макетом, що й повна форма) отримує її групи
 * назад. Порожній результат — null (перевизначення вилучити). Чиста функція.
 */
export function resetFormPatch(patch: IRecordTypeOverride, rt: IRecordTypeDefinition, published?: IRecordTypeDefinition): IRecordTypeOverride | null {
  const out = withWidths(patch, {});
  const base = published ?? rt;
  if (isSeededLayout(base)) {
    out.forms = { ...(out.forms ?? {}), full: formPatchOf(rt, standardFormOf(rt, base.form.tabs), published) };
    return out;
  }
  const { full: _full, ...rest } = out.forms ?? {};
  const shape = rest.context?.groups;
  out.forms = shape ? { ...rest, full: { groups: shape } } : rest;
  if (!Object.keys(out.forms).length) delete out.forms;
  return Object.keys(out).length ? out : null;
}
